var render = function render(_c,_vm){return _c('button',_vm._g({staticClass:"Vlt-btn Vlt-btn--no-focus",class:[{
    'Vlt-btn--icon': !_vm.props.label,
    'Vlt-btn--disabled': _vm.props.disabled,
    'Vlt-btn--app': _vm.props.app,
    'Vlt-btn--primary': _vm.props.primary,
    'Vlt-btn--quaternary': _vm.props.quaternary,
    'Vlt-btn--secondary': _vm.props.secondary,
    'Vlt-btn--destructive': _vm.props.destructive,
    'Vlt-btn--tertiary':
      !(_vm.props.secondary || _vm.props.primary || _vm.props.destructive || _vm.props.quaternary),
    'Vlt-btn--small': _vm.props.small,
    'Vlt-btn--large': _vm.props.large,
  }, _vm.data.staticClass, _vm.data.class
  ],attrs:{"id":_vm.props.id,"disabled":_vm.props.disabled}},_vm.listeners),[(_vm.props.icon)?_c(_vm.injections.components.VltIcon,{tag:"component",attrs:{"icon":_vm.props.icon}}):_vm._e(),(_vm.props.spinner || _vm.props.spinnerWhite)?_c(_vm.injections.components.VltSpinner,{tag:"component",attrs:{"smaller":true,"white":_vm.props.spinnerWhite}}):_vm._e(),_vm._t("default",function(){return [_vm._v(_vm._s(_vm.props.label))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }